import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Image, Link } from '@react-pdf/renderer';

// Vaster Logo as base64 (more reliable for PDF generation)
const VASTER_LOGO_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAAA5CAMAAABeUSO3AAAAPFBMVEUAAAAAL4cALoYAMIcALocAL4cALoAAL4cAL4cALYYALoQALocALoYALYcAL4cALIcAL4YAMIcAKIcAL4d7BYyqAAAAE3RSTlMA318gf78Qn+8/H49vT88vr0AgaEhzXgAABNJJREFUeNrdm9l2gyAURUEZBafw///aJiYhlsi5hnZVPI9xwu0dgbCDSFnvtNZO9COrXwP/1qAYUMOvGhEa8S3PdstKE54yUwNO5xT17K1aDtWxXZfKSVi2lghXWQbEr2dxhnRjo9g+XWT4Ia47llGgqNkgE6A6Bi8FA17OlCyvMVylGdDyiQTbJW/CG4mqoH5rhVXeXA5Yl45Pw/AN2yOx9fG7uqCG14Djw1We4P0Dw5IgmGCmUb4uqK/epQz2fxuHCeTjzUjqH9nJ9e113LOXOATwH1ru8E+J6j3V5S0Uxfux1L5Upe5jcupl7M1joJx4n/jJ/0Nqdk+ydm2GHib1iVHkEhPDzm/mpIC7c6oBahxwNAOC/zfhqp5RZHelqmUsc+pp+lZsVAP1mRvEyrhCprCfkiIVWbXdE1H1++BsupqgLhRjGWVBYXiJr06QAKGCGqsbz6qCes9NfuWEBnj/TI3b8YNBDdnAUxnUxTYlsVWV0PvT0wWdhjgJ1HsbtTKu4LLe7/eVngPZqIM/C1Qfg1lknM1rHaNKkVNVey6ofQyTkbHNlD1ybx50FKjncv82jiMa14Rb1B2lqqLSmE4KlemEAziEI7an1v5GnRRqxhw5KFJLZlWmxf9PAnX82Xhutqo2KVKpWd1S86UZzwE1JqpVilcb3s8/qdgc1WGCsaeAqh8M0VSVMoAPSFWQ/iLXnQBqOpMv3/t/E4vUPTLEVDW+rJzVDnVB5TIlPmCNJKiX+fCUbLqaoV54SlC9TcSXzHixBVpaIIoaXK/+GKoSeYHnozUMDaZNoPeXp6roIkSDLYfaolW/AjtNL2/eGdfwacvjk1QFlyKiZF8ZVCVMnPhHef4C1lHQrIqnvadIsPKmHqiqdyYscu/nQUz6E2efyO3JcG1qrbo7HNSWv5N5GfNW72QLWtT0biM9tbnh5w6Vw0EFl7rN4lIDMGSZ3W1922seosz4JyVVm9fH34PP23nYqP0tKuVu5EAwRKrdserUHFTpiVNXjJcMVn2a5Fr9HGklUAf/YuCgfeop6RDfrQCrPRZUmSpAf/TraRaNqeCZMFWy30MeCur2jNBELi4VZawXvL2whKo6OtQx3NRTPbah7IrSCKopMoHm6FCZgAHAvkZRSSlSeUCyRRNph4eqFgIO+b94cewZvTqULCke9OGhMgttZ+lLIy8ON0NhqYLmQR4fKnNog7KN1AeC+6kmL1OQqngtUHEA4I/jlxheS7dsnRwqDgBLc7lzlgka/qYyh2qJqc8SiCuwZE9qUcsDYx9EvgAUVUBVJhcAYiFlS7wfbyeIaxAi293NVUBl/T0AgHUQjZwPC9vblDnI6+ioVq0KV1lTbjhovopTVWxFh27zmD58739XCwKAvmFARSoW3vkqwiLutw7NtUBlPg0AacYu936885WJjXU+5Zafp2PNpxICwJDJ2IvGX+s3jAJUA9f2cU4nzB/O/CsNpQoCgMhk7Ei9VDb7rN6EKC4nrYf4i/+PhT9c8+SxjRkMv+dPJvuBWpmZia0KKhuy80cS3nv/F7Rgg0oi07DKoNqsf4mIvEDgT1oAq+xYbVCZy2UC9bvZVOK16n4ya6QzY/VBVTxnjV58i/2WVHsVSqmzn+R1UHxwzd70Gx9AUAvFSvUFNQfm/rZtV50AAAAASUVORK5CYII=';

// Register fonts
Font.register({
  family: 'Helvetica',
  fonts: [
    { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5Q.ttf', fontWeight: 400 },
    { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAw.ttf', fontWeight: 700 },
  ],
});

// Signature script font (served from /public/fonts)
Font.register({
  family: 'GreatVibes',
  src: `${window.location.origin}/fonts/GreatVibes-Regular.ttf`,
});
const colors = {
  primary: '#002F87',
  accent: '#FFFF00',
  text: '#1E293B',
  textMuted: '#637888',
  border: '#E2E8F0',
  background: '#F8FAFC',
  white: '#FFFFFF',
};

// Compact styles for single-page layout
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica',
    fontSize: 9,
    color: colors.text,
    backgroundColor: colors.white,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 2,
    borderBottomColor: colors.primary,
  },
  logo: {
    width: 100,
    height: 20,
  },
  logoText: {
    fontSize: 20,
    fontWeight: 700,
    color: colors.primary,
    letterSpacing: -1,
  },
  dateText: {
    fontSize: 8,
    color: colors.textMuted,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: colors.primary,
    marginBottom: 4,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 10,
    color: colors.textMuted,
    textAlign: 'center',
    marginBottom: 12,
  },
  section: {
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 9,
    fontWeight: 700,
    color: colors.primary,
    marginBottom: 6,
    paddingBottom: 2,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  // Project info in compact row
  projectInfoRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  projectInfoItem: {
    width: '25%',
    marginBottom: 4,
  },
  projectInfoLabel: {
    fontSize: 7,
    color: colors.textMuted,
    textTransform: 'uppercase',
    marginBottom: 1,
  },
  projectInfoValue: {
    fontSize: 9,
    color: colors.text,
  },
  // Compact metrics grid
  metricsRow: {
    flexDirection: 'row',
    marginBottom: 10,
    gap: 6,
  },
  metricBox: {
    flex: 1,
    padding: 8,
    backgroundColor: colors.background,
    borderRadius: 3,
  },
  metricBoxHighlight: {
    flex: 1,
    padding: 8,
    backgroundColor: colors.primary,
    borderRadius: 3,
  },
  metricLabel: {
    fontSize: 7,
    color: colors.textMuted,
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  metricLabelHighlight: {
    fontSize: 7,
    color: colors.white,
    opacity: 0.8,
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  metricValue: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.primary,
  },
  metricValueHighlight: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.white,
  },
  // Two column layout
  twoColumn: {
    flexDirection: 'row',
    gap: 12,
  },
  column: {
    flex: 1,
  },
  // Compact table
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: colors.primary,
    padding: 5,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
  tableHeaderCell: {
    flex: 1,
    fontSize: 7,
    fontWeight: 700,
    color: colors.white,
    textTransform: 'uppercase',
  },
  tableHeaderCellRight: {
    flex: 1,
    fontSize: 7,
    fontWeight: 700,
    color: colors.white,
    textTransform: 'uppercase',
    textAlign: 'right',
  },
  tableRow: {
    flexDirection: 'row',
    padding: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  tableRowAlt: {
    flexDirection: 'row',
    padding: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    backgroundColor: colors.background,
  },
  tableRowTotal: {
    flexDirection: 'row',
    padding: 4,
    backgroundColor: colors.background,
    borderTopWidth: 1,
    borderTopColor: colors.primary,
  },
  tableCell: {
    flex: 1,
    fontSize: 8,
    color: colors.text,
  },
  tableCellRight: {
    flex: 1,
    fontSize: 8,
    color: colors.text,
    textAlign: 'right',
    fontFamily: 'Courier',
  },
  tableCellTotal: {
    flex: 1,
    fontSize: 8,
    fontWeight: 700,
    color: colors.primary,
  },
  tableCellTotalRight: {
    flex: 1,
    fontSize: 8,
    fontWeight: 700,
    color: colors.primary,
    textAlign: 'right',
    fontFamily: 'Courier',
  },
  // Loan structure compact
  loanStructureRow: {
    flexDirection: 'row',
    marginBottom: 3,
  },
  loanStructureLabel: {
    width: '50%',
    fontSize: 8,
    color: colors.textMuted,
  },
  loanStructureValue: {
    width: '50%',
    fontSize: 8,
    color: colors.text,
    textAlign: 'right',
  },
  // Assumptions box
  assumptions: {
    marginTop: 8,
    padding: 8,
    backgroundColor: colors.background,
    borderRadius: 2,
    borderLeftWidth: 3,
    borderLeftColor: colors.accent,
  },
  assumptionsTitle: {
    fontSize: 8,
    fontWeight: 700,
    color: colors.primary,
    marginBottom: 4,
    textTransform: 'uppercase',
  },
  assumptionItem: {
    fontSize: 7,
    color: colors.textMuted,
    marginBottom: 2,
  },
  // Footer
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  disclaimer: {
    fontSize: 6,
    color: colors.textMuted,
    lineHeight: 1.3,
    textAlign: 'center',
  },
  // Loan Officer Contact Box
  loanOfficerBox: {
    marginTop: 10,
    padding: 10,
    backgroundColor: colors.primary,
    borderRadius: 3,
  },
  loanOfficerTitle: {
    fontSize: 8,
    fontWeight: 700,
    color: colors.white,
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  loanOfficerRow: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  loanOfficerLabel: {
    fontSize: 7,
    color: colors.white,
    opacity: 0.7,
    width: 50,
  },
  loanOfficerValue: {
    fontSize: 8,
    color: colors.white,
    fontWeight: 500,
  },
  loanOfficerName: {
    fontSize: 10,
    fontWeight: 700,
    color: colors.white,
    marginBottom: 2,
  },
  loanOfficerTitleText: {
    fontSize: 8,
    color: colors.white,
    opacity: 0.8,
    marginBottom: 4,
  },
  // Executive summary compact
  executiveSummary: {
    padding: 8,
    backgroundColor: colors.background,
    borderRadius: 2,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: colors.border,
  },
  executiveSummaryText: {
    fontSize: 8,
    color: colors.text,
    lineHeight: 1.4,
  },
});

// Format currency
const formatCurrency = (value) => {
  if (!value && value !== 0) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

// Format percentage
const formatPercentage = (value, decimals = 1) => {
  if (!value && value !== 0) return '0%';
  return `${value.toFixed(decimals)}%`;
};

// Loan Officer Contact Component (reusable)
const LoanOfficerContact = ({ loanOfficer }) => {
  if (!loanOfficer) return null;
  
  return (
    <View style={styles.loanOfficerBox}>
      <Text style={styles.loanOfficerTitle}>Your Loan Officer</Text>
      <Text style={styles.loanOfficerName}>{loanOfficer.name}</Text>
      <Text style={styles.loanOfficerTitleText}>
        {loanOfficer.title}{loanOfficer.nmls ? ` | NMLS#${loanOfficer.nmls}` : ''}
      </Text>
      {loanOfficer.email && (
        <View style={styles.loanOfficerRow}>
          <Text style={styles.loanOfficerLabel}>Email:</Text>
          <Text style={styles.loanOfficerValue}>{loanOfficer.email}</Text>
        </View>
      )}
      {loanOfficer.phone && (
        <View style={styles.loanOfficerRow}>
          <Text style={styles.loanOfficerLabel}>Phone:</Text>
          <Text style={styles.loanOfficerValue}>{loanOfficer.phone}</Text>
        </View>
      )}
    </View>
  );
};

// PDF Document Component - Single Page Optimized
export const LoanSummaryPDF = ({ data, inputs, loanType = 'construction', loanOfficer }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const loanTypeLabel = loanType === 'construction' ? 'Construction' : 'Bridge';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image style={styles.logo} src={VASTER_LOGO_BASE64} />
          <Text style={styles.dateText}>Generated: {currentDate}</Text>
        </View>

        {/* Title */}
        <Text style={styles.title}>{loanTypeLabel} Loan Summary</Text>
        <Text style={styles.subtitle}>
          {inputs.projectName || 'New Project'} | {inputs.propertyAddress || 'Address TBD'}
        </Text>

        {/* Executive Summary - Compact */}
        <View style={styles.executiveSummary}>
          <Text style={styles.executiveSummaryText}>
            Proposed financing for {inputs.propertyAddress || '[Property Address]'}: 
            Total project cost of {formatCurrency(data.totalProjectCost)} with recommended loan of {formatCurrency(data.finalLoanAmount)} ({formatPercentage(data.resultingLTV)} LTV). 
            Borrower equity requirement: {formatCurrency(data.equityRequirement)}.
          </Text>
        </View>

        {/* Project Info Row */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Project Information</Text>
          <View style={styles.projectInfoRow}>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Project Name</Text>
              <Text style={styles.projectInfoValue}>{inputs.projectName || '-'}</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Property Address</Text>
              <Text style={styles.projectInfoValue}>{inputs.propertyAddress || '-'}</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Loan Type</Text>
              <Text style={styles.projectInfoValue}>{loanTypeLabel} Loan</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Acquisition Cost</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data.acquisitionCost)}</Text>
            </View>
          </View>
        </View>

        {/* Key Metrics Row */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Key Metrics</Text>
          <View style={styles.metricsRow}>
            <View style={styles.metricBoxHighlight}>
              <Text style={styles.metricLabelHighlight}>Loan Amount</Text>
              <Text style={styles.metricValueHighlight}>{formatCurrency(data.finalLoanAmount)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Equity Required</Text>
              <Text style={styles.metricValue}>{formatCurrency(data.equityRequirement)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Total Project Cost</Text>
              <Text style={styles.metricValue}>{formatCurrency(data.totalProjectCost)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Resulting LTV</Text>
              <Text style={styles.metricValue}>{formatPercentage(data.resultingLTV)}</Text>
            </View>
          </View>
        </View>

        {/* Sources and Uses - Two Column */}
        <View style={styles.twoColumn}>
          {/* Sources */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Sources of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Source</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Loan Amount</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.finalLoanAmount)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Borrower Equity</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.equityRequirement)}</Text>
              </View>
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Sources</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalSources)}</Text>
              </View>
            </View>
          </View>

          {/* Uses */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Uses of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Use</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Construction Costs</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.constructionCosts)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Existing Debt</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.existingDebt)}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Closing Costs (4.5%)</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.closingCosts)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Interest Reserve</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.interestReserve)}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Reserves / Fees</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.totalReserves)}</Text>
              </View>
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Uses</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalUses)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Loan Structure - Compact */}
        <View style={[styles.section, { marginTop: 10 }]}>
          <Text style={styles.sectionTitle}>Loan Structure</Text>
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Loan Term</Text>
                <Text style={styles.loanStructureValue}>{inputs.loanTerm || '-'} months</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Interest Rate</Text>
                <Text style={styles.loanStructureValue}>{inputs.interestRate || '-'}% ({inputs.rateType || 'Variable'})</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Target LTV</Text>
                <Text style={styles.loanStructureValue}>{inputs.targetLTV || '-'}%</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Target LTC</Text>
                <Text style={styles.loanStructureValue}>{inputs.targetLTC || '-'}%</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Initial Funding</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.initialFunding)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Construction Funding</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.constructionFunding)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Assumptions - Compact */}
        <View style={styles.assumptions}>
          <Text style={styles.assumptionsTitle}>Assumptions</Text>
          <Text style={styles.assumptionItem}>• Closing Cost Estimate: 4.5% of loan amount</Text>
          <Text style={styles.assumptionItem}>• Loan constrained by As-Is LTV and As-Completed LTC limits</Text>
          <Text style={styles.assumptionItem}>• All figures are estimates subject to final underwriting and appraisal</Text>
        </View>

        {/* Loan Officer Contact */}
        <LoanOfficerContact loanOfficer={loanOfficer} />

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.disclaimer}>
            This summary is for informational purposes only and does not constitute a loan commitment or offer. 
            All terms are subject to final underwriting, credit approval, and property appraisal. 
            Vaster reserves the right to modify terms at any time. Contact your loan officer for complete details.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Bridge Loan PDF Document Component
export const BridgeLoanSummaryPDF = ({ data, inputs, transactionType = 'refinance', loanOfficer }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (!data) return null;

  const isPurchase = transactionType === 'purchase';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image style={styles.logo} src={VASTER_LOGO_BASE64} />
          <Text style={styles.dateText}>Generated: {currentDate}</Text>
        </View>

        {/* Title */}
        <Text style={styles.title}>Bridge Loan Summary</Text>
        <Text style={styles.subtitle}>
          {isPurchase ? 'Purchase' : 'Refinance Cash-Out'} | {inputs.projectName || 'New Project'} | {inputs.propertyAddress || 'Address TBD'}
        </Text>

        {/* Executive Summary - Compact */}
        <View style={styles.executiveSummary}>
          {isPurchase ? (
            <Text style={styles.executiveSummaryText}>
              Purchase financing for {inputs.propertyAddress || '[Property Address]'}: 
              Purchase price of {formatCurrency(data.purchasePrice)} with loan amount of {formatCurrency(data.loanAmount)} ({formatPercentage(data.purchaseLTV)} LTV). 
              ARV: {formatCurrency(data.afterRepairValue)} ({formatPercentage(data.arvLTV)} ARV LTV). Cash to close: {formatCurrency(data.cashToClose)}.
            </Text>
          ) : (
            <Text style={styles.executiveSummaryText}>
              Refinance cash-out for {inputs.propertyAddress || '[Property Address]'}: 
              Property valued at {formatCurrency(data.propertyValue)} with loan amount of {formatCurrency(data.loanAmount)} ({formatPercentage(data.ltv)} LTV). 
              Existing payoff: {formatCurrency(data.payoffAmount)}. Net cash-out to borrower: {formatCurrency(data.cashOut)}.
            </Text>
          )}
        </View>

        {/* Key Metrics Row */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Key Metrics</Text>
          <View style={styles.metricsRow}>
            <View style={styles.metricBoxHighlight}>
              <Text style={styles.metricLabelHighlight}>Loan Amount</Text>
              <Text style={styles.metricValueHighlight}>{formatCurrency(data.loanAmount)}</Text>
            </View>
            {isPurchase ? (
              <View style={[styles.metricBox, { backgroundColor: '#FFFBEB' }]}>
                <Text style={[styles.metricLabel, { color: '#B45309' }]}>Cash to Close</Text>
                <Text style={[styles.metricValue, { color: '#B45309' }]}>{formatCurrency(data.cashToClose)}</Text>
              </View>
            ) : (
              <View style={[styles.metricBox, { backgroundColor: '#ECFDF5' }]}>
                <Text style={[styles.metricLabel, { color: '#047857' }]}>Cash Out</Text>
                <Text style={[styles.metricValue, { color: '#047857' }]}>{formatCurrency(data.cashOut)}</Text>
              </View>
            )}
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Monthly Payment</Text>
              <Text style={styles.metricValue}>{formatCurrency(data.monthlyPayment)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>{isPurchase ? 'Purchase LTV' : 'Loan-to-Value'}</Text>
              <Text style={styles.metricValue}>{formatPercentage(isPurchase ? data.purchaseLTV : data.ltv)}</Text>
            </View>
          </View>
        </View>

        {/* Sources and Uses - Two Column */}
        <View style={styles.twoColumn}>
          {/* Sources */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Sources of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Source</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Loan Amount</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.loanAmount)}</Text>
              </View>
              {isPurchase ? (
                <View style={styles.tableRowAlt}>
                  <Text style={styles.tableCell}>Cash to Close</Text>
                  <Text style={styles.tableCellRight}>{formatCurrency(data.cashToClose)}</Text>
                </View>
              ) : (
                data.equityRequired > 0 && (
                  <View style={styles.tableRowAlt}>
                    <Text style={styles.tableCell}>Borrower Equity</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.equityRequired)}</Text>
                  </View>
                )
              )}
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Sources</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalSources)}</Text>
              </View>
            </View>
          </View>

          {/* Uses */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Uses of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Use</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              {isPurchase ? (
                <>
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>Purchase Price</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.purchasePrice)}</Text>
                  </View>
                  <View style={styles.tableRowAlt}>
                    <Text style={styles.tableCell}>Total Closing Costs</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.totalClosingCosts)}</Text>
                  </View>
                </>
              ) : (
                <>
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>Existing Loan Payoff</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.payoffAmount)}</Text>
                  </View>
                  <View style={styles.tableRowAlt}>
                    <Text style={styles.tableCell}>Total Closing Costs</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.totalClosingCosts)}</Text>
                  </View>
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>Cash Out to Borrower</Text>
                    <Text style={styles.tableCellRight}>{formatCurrency(data.cashOut)}</Text>
                  </View>
                </>
              )}
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Uses</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalUses)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Closing Costs Breakdown */}
        <View style={[styles.section, { marginTop: 10 }]}>
          <Text style={styles.sectionTitle}>Closing Costs Breakdown</Text>
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Lender Origination ({data.lenderOriginationFeePercent ?? 0}%)</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.lenderOriginationFee)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Broker Origination ({data.brokerOriginationFeePercent ?? 0}%)</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.brokerOriginationFee)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Title/Closing Fees</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.totalTitleFees)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Fixed Fees</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.totalFixedFees)}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Interest Reserve</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.interestReserve)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Pre-Paid Interest</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.prePaidInterest)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Total Pre-Paids</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.totalPrePaids)}</Text>
              </View>
              <View style={[styles.loanStructureRow, { marginTop: 4 }]}>
                <Text style={[styles.loanStructureLabel, { fontWeight: 700, color: '#002F87' }]}>Total Closing</Text>
                <Text style={[styles.loanStructureValue, { fontWeight: 700, color: '#002F87' }]}>{formatCurrency(data.totalClosingCosts)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Loan Structure - Compact */}
        <View style={[styles.section, { marginTop: 10 }]}>
          <Text style={styles.sectionTitle}>Loan Structure</Text>
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>{isPurchase ? 'Purchase Price' : 'Property Value'}</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(isPurchase ? data.purchasePrice : data.propertyValue)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Loan Term</Text>
                <Text style={styles.loanStructureValue}>{inputs.loanTerm || '-'} months</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Interest Rate</Text>
                <Text style={styles.loanStructureValue}>{inputs.interestRate || '-'}% ({inputs.rateType || 'Fixed'})</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>{isPurchase ? 'Purchase LTV' : 'Loan-to-Value'}</Text>
                <Text style={styles.loanStructureValue}>{formatPercentage(isPurchase ? data.purchaseLTV : data.ltv)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Monthly Payment (IO)</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.monthlyPayment)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Payment Type</Text>
                <Text style={styles.loanStructureValue}>Interest-Only</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Assumptions - Compact */}
        <View style={styles.assumptions}>
          <Text style={styles.assumptionsTitle}>Fee Schedule</Text>
          <Text style={styles.assumptionItem}>• Origination fees: {data.lenderOriginationFeePercent ?? 0}% lender + {data.brokerOriginationFeePercent ?? 0}% broker</Text>
          <Text style={styles.assumptionItem}>• Doc stamps: 0.35% | Intangible tax: 0.2% | Title insurance per FL schedule</Text>
          <Text style={styles.assumptionItem}>• All figures are estimates subject to final underwriting and appraisal</Text>
        </View>

        {/* Application CTA — identical to IOI */}
        {loanOfficer?.applicationLink && (
          <View style={[ioiStyles.applyBox, { paddingVertical: 6, marginBottom: 6 }]}>
            <View style={{ flex: 1 }}>
              <Text style={ioiStyles.applyTitle}>Start Your Application Today</Text>
              <Text style={ioiStyles.applySub}>
                Secure online application — takes less than 10 minutes, with no obligation.
                {'\n'}Lock in these terms while they are available.
              </Text>
              <Text style={ioiStyles.applyUrl}>
                Or visit:{' '}
                <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={ioiStyles.applyUrlLink}>
                  {loanOfficer.applicationLink}
                </Link>
              </Text>
            </View>
            <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={ioiStyles.applyBtn}>
              <Text style={ioiStyles.applyBtnText}>APPLY NOW</Text>
            </Link>
          </View>
        )}

        {/* Signature Block */}
        <View style={{ marginBottom: 4 }}>
          <Text style={ioiStyles.sectionTitle}>Acknowledged &amp; Accepted</Text>
          <View style={[ioiStyles.twoCol, { marginTop: 4 }]}>
            <View style={ioiStyles.col}>
              <View style={[ioiStyles.sigLine, { height: 32 }]} />
              <Text style={ioiStyles.sigLabel}>Borrower Signature &amp; Date</Text>
            </View>
            <View style={ioiStyles.col}>
              <View style={[ioiStyles.sigLine, { height: 32, flexDirection: 'row', alignItems: 'flex-end', paddingBottom: 1 }]}>
                <Text style={{ fontFamily: 'GreatVibes', fontSize: 14, color: '#1a2332' }}>
                  {loanOfficer?.name || ''}
                </Text>
              </View>
              <Text style={ioiStyles.sigLabel}>Vaster — Authorized Representative &amp; Date</Text>
            </View>
          </View>
        </View>

        {/* Loan Officer Contact */}
        <LoanOfficerContact loanOfficer={loanOfficer} />

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.disclaimer}>
            This summary is for informational purposes only and does not constitute a loan commitment or offer. 
            All terms are subject to final underwriting, credit approval, and property appraisal. 
            Vaster reserves the right to modify terms at any time. Contact your loan officer for complete details.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Portfolio/Developer Loan PDF Document Component
export const PortfolioLoanSummaryPDF = ({ data, inputs, loanOfficer }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (!data) return null;

  // Compact styles for single-page layout
  const compactStyles = StyleSheet.create({
    page: {
      padding: 24,
      fontFamily: 'Helvetica',
      fontSize: 8,
      color: colors.text,
      backgroundColor: colors.white,
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 8,
      paddingBottom: 6,
      borderBottomWidth: 2,
      borderBottomColor: colors.primary,
    },
    logo: {
      width: 80,
      height: 16,
    },
    dateText: {
      fontSize: 7,
      color: colors.textMuted,
    },
    title: {
      fontSize: 14,
      fontWeight: 700,
      color: colors.primary,
      marginBottom: 2,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 8,
      color: colors.textMuted,
      textAlign: 'center',
      marginBottom: 8,
    },
    executiveSummary: {
      backgroundColor: '#EAF5FD',
      padding: 6,
      borderRadius: 3,
      marginBottom: 8,
      borderLeftWidth: 3,
      borderLeftColor: colors.primary,
    },
    executiveSummaryText: {
      fontSize: 7,
      color: colors.text,
      lineHeight: 1.3,
    },
    section: {
      marginBottom: 6,
    },
    sectionTitle: {
      fontSize: 8,
      fontWeight: 700,
      color: colors.primary,
      marginBottom: 4,
      paddingBottom: 2,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      textTransform: 'uppercase',
      letterSpacing: 0.3,
    },
    metricsRow: {
      flexDirection: 'row',
      gap: 4,
    },
    metricBox: {
      flex: 1,
      backgroundColor: colors.background,
      padding: 5,
      borderRadius: 3,
      alignItems: 'center',
    },
    metricBoxHighlight: {
      flex: 1,
      backgroundColor: colors.primary,
      padding: 5,
      borderRadius: 3,
      alignItems: 'center',
    },
    metricLabel: {
      fontSize: 6,
      color: colors.textMuted,
      textTransform: 'uppercase',
      marginBottom: 1,
    },
    metricLabelHighlight: {
      fontSize: 6,
      color: colors.white,
      textTransform: 'uppercase',
      marginBottom: 1,
      opacity: 0.8,
    },
    metricValue: {
      fontSize: 10,
      fontWeight: 700,
      color: colors.text,
    },
    metricValueHighlight: {
      fontSize: 10,
      fontWeight: 700,
      color: colors.white,
    },
    twoColumn: {
      flexDirection: 'row',
      gap: 8,
    },
    column: {
      flex: 1,
    },
    tableHeader: {
      flexDirection: 'row',
      backgroundColor: colors.primary,
      padding: 3,
      borderTopLeftRadius: 2,
      borderTopRightRadius: 2,
    },
    tableHeaderCell: {
      flex: 1,
      fontSize: 6,
      fontWeight: 700,
      color: colors.white,
      textTransform: 'uppercase',
    },
    tableHeaderCellRight: {
      flex: 1,
      fontSize: 6,
      fontWeight: 700,
      color: colors.white,
      textAlign: 'right',
      textTransform: 'uppercase',
    },
    tableRow: {
      flexDirection: 'row',
      padding: 3,
      backgroundColor: colors.white,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    tableRowAlt: {
      flexDirection: 'row',
      padding: 3,
      backgroundColor: colors.background,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    tableCell: {
      flex: 1,
      fontSize: 7,
      color: colors.text,
    },
    tableCellRight: {
      flex: 1,
      fontSize: 7,
      color: colors.text,
      textAlign: 'right',
    },
    tableRowTotal: {
      flexDirection: 'row',
      padding: 3,
      backgroundColor: '#EAF5FD',
      borderBottomLeftRadius: 2,
      borderBottomRightRadius: 2,
    },
    tableCellTotal: {
      flex: 1,
      fontSize: 7,
      fontWeight: 700,
      color: colors.primary,
    },
    tableCellTotalRight: {
      flex: 1,
      fontSize: 7,
      fontWeight: 700,
      color: colors.primary,
      textAlign: 'right',
    },
    loanStructureRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingVertical: 2,
    },
    loanStructureLabel: {
      fontSize: 7,
      color: colors.textMuted,
    },
    loanStructureValue: {
      fontSize: 7,
      color: colors.text,
      fontWeight: 500,
    },
    assumptions: {
      backgroundColor: colors.background,
      padding: 5,
      borderRadius: 3,
      marginTop: 6,
      borderLeftWidth: 2,
      borderLeftColor: colors.accent,
    },
    assumptionsTitle: {
      fontSize: 7,
      fontWeight: 700,
      color: colors.primary,
      marginBottom: 2,
    },
    assumptionItem: {
      fontSize: 6,
      color: colors.textMuted,
      marginBottom: 1,
    },
    footer: {
      position: 'absolute',
      bottom: 16,
      left: 24,
      right: 24,
      borderTopWidth: 1,
      borderTopColor: colors.border,
      paddingTop: 6,
    },
    disclaimer: {
      fontSize: 5,
      color: colors.textMuted,
      textAlign: 'center',
      lineHeight: 1.3,
    },
    loanOfficerSection: {
      marginTop: 6,
      padding: 5,
      backgroundColor: colors.background,
      borderRadius: 3,
    },
    loanOfficerName: {
      fontSize: 8,
      fontWeight: 700,
      color: colors.primary,
    },
    loanOfficerDetail: {
      fontSize: 6,
      color: colors.textMuted,
      marginTop: 1,
    },
  });

  return (
    <Document>
      <Page size="A4" style={compactStyles.page}>
        {/* Header */}
        <View style={compactStyles.header}>
          <Image style={compactStyles.logo} src={VASTER_LOGO_BASE64} />
          <Text style={compactStyles.dateText}>Generated: {currentDate}</Text>
        </View>

        {/* Title */}
        <Text style={compactStyles.title}>Standard Loan Summary</Text>
        <Text style={compactStyles.subtitle}>
          {inputs.transactionType === 'developer' && 'Developer'}
          {inputs.transactionType === 'refinance_cashout' && 'Refinance Cash-Out'}
          {inputs.transactionType === 'purchase' && 'Purchase'}
          {!inputs.transactionType && 'Standard'} | {inputs.amortizationTerm}yr Amortization | {inputs.projectName || 'New Project'}
        </Text>

        {/* Executive Summary */}
        <View style={compactStyles.executiveSummary}>
          <Text style={compactStyles.executiveSummaryText}>
            {inputs.transactionType === 'developer' ? 'Developer financing' : 
             inputs.transactionType === 'refinance_cashout' ? 'Refinance cash-out' : 
             'Purchase financing'} for {inputs.propertyAddress || '[Property Address]'}: 
            {inputs.transactionType === 'refinance_cashout' 
              ? `Property value of ${formatCurrency(data.purchasePrice)} with loan amount of ${formatCurrency(data.loanAmount)} (${data.targetLTV}% LTV). Existing mortgage: ${formatCurrency(data.existingMortgageBalance)}. Cash out: ${formatCurrency(data.cashOutAmount)}.`
              : `Purchase price of ${formatCurrency(data.purchasePrice)} with loan amount of ${formatCurrency(data.loanAmount)} (${data.targetLTV}% LTV). Monthly P&I: ${formatCurrency(data.piPayment)}. Total PITI+HOA: ${formatCurrency(data.totalMonthlyPayment)}. Cash to close: ${formatCurrency(data.cashToClose)}.`
            }
          </Text>
        </View>

        {/* Key Metrics Row */}
        <View style={compactStyles.section}>
          <Text style={compactStyles.sectionTitle}>Key Metrics</Text>
          <View style={compactStyles.metricsRow}>
            <View style={compactStyles.metricBoxHighlight}>
              <Text style={compactStyles.metricLabelHighlight}>Loan Amount</Text>
              <Text style={compactStyles.metricValueHighlight}>{formatCurrency(data.loanAmount)}</Text>
            </View>
            <View style={[compactStyles.metricBox, { backgroundColor: '#EFF6FF' }]}>
              <Text style={[compactStyles.metricLabel, { color: '#1D4ED8' }]}>IO Payment</Text>
              <Text style={[compactStyles.metricValue, { color: '#1D4ED8' }]}>{formatCurrency(data.ioPayment)}</Text>
            </View>
            <View style={[compactStyles.metricBox, { backgroundColor: '#ECFDF5' }]}>
              <Text style={[compactStyles.metricLabel, { color: '#047857' }]}>P&I Payment</Text>
              <Text style={[compactStyles.metricValue, { color: '#047857' }]}>{formatCurrency(data.piPayment)}</Text>
            </View>
            {inputs.transactionType === 'refinance_cashout' ? (
              <View style={[compactStyles.metricBox, { backgroundColor: '#ECFDF5' }]}>
                <Text style={[compactStyles.metricLabel, { color: '#047857' }]}>Cash Out</Text>
                <Text style={[compactStyles.metricValue, { color: '#047857' }]}>{formatCurrency(data.cashOutAmount || 0)}</Text>
              </View>
            ) : (
              <View style={[compactStyles.metricBox, { backgroundColor: data.cashToClose < 0 ? '#ECFDF5' : '#FFFBEB' }]}>
                <Text style={[compactStyles.metricLabel, { color: data.cashToClose < 0 ? '#047857' : '#B45309' }]}>
                  {data.cashToClose < 0 ? 'Credit to Borrower' : 'Cash to Close'}
                </Text>
                <Text style={[compactStyles.metricValue, { color: data.cashToClose < 0 ? '#047857' : '#B45309' }]}>
                  {data.cashToClose < 0 ? `(${formatCurrency(Math.abs(data.cashToClose))})` : formatCurrency(data.cashToClose)}
                </Text>
              </View>
            )}
          </View>
        </View>

        {/* Monthly Payment Breakdown */}
        <View style={compactStyles.section}>
          <Text style={compactStyles.sectionTitle}>Total Monthly Payment (PITI + HOA)</Text>
          <View style={compactStyles.metricsRow}>
            <View style={[compactStyles.metricBoxHighlight, { flex: 2 }]}>
              <Text style={compactStyles.metricLabelHighlight}>Total Monthly</Text>
              <Text style={compactStyles.metricValueHighlight}>{formatCurrency(data.totalMonthlyPayment)}</Text>
            </View>
            <View style={compactStyles.metricBox}>
              <Text style={compactStyles.metricLabel}>P&I</Text>
              <Text style={compactStyles.metricValue}>{formatCurrency(data.piPayment)}</Text>
            </View>
            <View style={compactStyles.metricBox}>
              <Text style={compactStyles.metricLabel}>Taxes</Text>
              <Text style={compactStyles.metricValue}>{formatCurrency(data.monthlyTaxes)}</Text>
            </View>
            <View style={compactStyles.metricBox}>
              <Text style={compactStyles.metricLabel}>Insurance</Text>
              <Text style={compactStyles.metricValue}>{formatCurrency(data.monthlyInsurance)}</Text>
            </View>
            <View style={compactStyles.metricBox}>
              <Text style={compactStyles.metricLabel}>HOA</Text>
              <Text style={compactStyles.metricValue}>{formatCurrency(data.monthlyHOA)}</Text>
            </View>
          </View>
        </View>

        {/* Sources and Uses - Two Column */}
        <View style={compactStyles.twoColumn}>
          {/* Sources */}
          <View style={compactStyles.column}>
            <Text style={compactStyles.sectionTitle}>Sources of Funds</Text>
            <View>
              <View style={compactStyles.tableHeader}>
                <Text style={compactStyles.tableHeaderCell}>Source</Text>
                <Text style={compactStyles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={compactStyles.tableRow}>
                <Text style={compactStyles.tableCell}>Loan Amount</Text>
                <Text style={compactStyles.tableCellRight}>{formatCurrency(data.loanAmount)}</Text>
              </View>
              <View style={compactStyles.tableRowAlt}>
                <Text style={[compactStyles.tableCell, data.cashToClose < 0 && { color: '#047857' }]}>
                  {data.cashToClose < 0 ? 'Credit to Borrower' : 'Cash to Close'}
                </Text>
                <Text style={[compactStyles.tableCellRight, data.cashToClose < 0 && { color: '#047857' }]}>
                  {data.cashToClose < 0 ? `(${formatCurrency(Math.abs(data.cashToClose))})` : formatCurrency(data.cashToClose)}
                </Text>
              </View>
              {inputs.transactionType !== 'refinance_cashout' && data.depositAmount > 0 && (
                <View style={compactStyles.tableRow}>
                  <Text style={compactStyles.tableCell}>Deposit Applied</Text>
                  <Text style={compactStyles.tableCellRight}>{formatCurrency(data.depositAmount)}</Text>
                </View>
              )}
              {inputs.transactionType !== 'refinance_cashout' && data.totalCredits > 0 && (
                <View style={compactStyles.tableRowAlt}>
                  <Text style={compactStyles.tableCell}>Credits Applied</Text>
                  <Text style={compactStyles.tableCellRight}>{formatCurrency(data.totalCredits)}</Text>
                </View>
              )}
              <View style={compactStyles.tableRowTotal}>
                <Text style={compactStyles.tableCellTotal}>Total Sources</Text>
                <Text style={compactStyles.tableCellTotalRight}>{formatCurrency(data.totalSources)}</Text>
              </View>
            </View>
          </View>

          {/* Uses */}
          <View style={compactStyles.column}>
            <Text style={compactStyles.sectionTitle}>Uses of Funds</Text>
            <View>
              <View style={compactStyles.tableHeader}>
                <Text style={compactStyles.tableHeaderCell}>Use</Text>
                <Text style={compactStyles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={compactStyles.tableRow}>
                <Text style={compactStyles.tableCell}>Purchase Price</Text>
                <Text style={compactStyles.tableCellRight}>{formatCurrency(data.purchasePrice)}</Text>
              </View>
              <View style={compactStyles.tableRowAlt}>
                <Text style={compactStyles.tableCell}>Closing Costs</Text>
                <Text style={compactStyles.tableCellRight}>{formatCurrency(data.totalClosingCosts)}</Text>
              </View>
              <View style={compactStyles.tableRowTotal}>
                <Text style={compactStyles.tableCellTotal}>Total Uses</Text>
                <Text style={compactStyles.tableCellTotalRight}>{formatCurrency(data.totalUses)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Deposit & Credits Breakdown - Only show if applicable and not Refinance Cash-Out */}
        {inputs.transactionType !== 'refinance_cashout' && (data.depositAmount > 0 || data.totalCredits > 0) && (
          <View style={compactStyles.section}>
            <Text style={compactStyles.sectionTitle}>Cash to Close Breakdown</Text>
            <View style={[compactStyles.assumptions, { borderLeftColor: data.cashToClose < 0 ? '#10B981' : '#F59E0B' }]}>
              {inputs.transactionType !== 'refinance_cashout' && (
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Down Payment</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.downPayment)}</Text>
                </View>
              )}
              <View style={compactStyles.loanStructureRow}>
                <Text style={compactStyles.loanStructureLabel}>+ Total Closing Costs</Text>
                <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.totalClosingCosts)}</Text>
              </View>
              {data.depositAmount > 0 && (
                <View style={compactStyles.loanStructureRow}>
                  <Text style={[compactStyles.loanStructureLabel, { color: '#047857' }]}>− Deposit ({data.depositPercent}%)</Text>
                  <Text style={[compactStyles.loanStructureValue, { color: '#047857' }]}>({formatCurrency(data.depositAmount)})</Text>
                </View>
              )}
              {data.developerCredit > 0 && inputs.transactionType === 'developer' && (
                <View style={compactStyles.loanStructureRow}>
                  <Text style={[compactStyles.loanStructureLabel, { color: '#047857' }]}>− Developer Credit</Text>
                  <Text style={[compactStyles.loanStructureValue, { color: '#047857' }]}>({formatCurrency(data.developerCredit)})</Text>
                </View>
              )}
              {data.lenderCredit > 0 && (
                <View style={compactStyles.loanStructureRow}>
                  <Text style={[compactStyles.loanStructureLabel, { color: '#047857' }]}>− Lender Credit</Text>
                  <Text style={[compactStyles.loanStructureValue, { color: '#047857' }]}>({formatCurrency(data.lenderCredit)})</Text>
                </View>
              )}
              <View style={[compactStyles.loanStructureRow, { marginTop: 2, paddingTop: 2, borderTopWidth: 1, borderTopColor: data.cashToClose < 0 ? '#10B981' : '#F59E0B' }]}>
                <Text style={[compactStyles.loanStructureLabel, { fontWeight: 700, color: data.cashToClose < 0 ? '#047857' : '#B45309' }]}>
                  = {data.cashToClose < 0 ? 'Credit to Borrower' : 'Cash to Close'}
                </Text>
                <Text style={[compactStyles.loanStructureValue, { fontWeight: 700, color: data.cashToClose < 0 ? '#047857' : '#B45309' }]}>
                  {data.cashToClose < 0 ? `(${formatCurrency(Math.abs(data.cashToClose))})` : formatCurrency(data.cashToClose)}
                </Text>
              </View>
            </View>
          </View>
        )}

        {/* Closing Costs & Loan Structure - Combined Two Column */}
        <View style={compactStyles.twoColumn}>
          {/* Closing Costs Breakdown */}
          <View style={compactStyles.column}>
            <Text style={compactStyles.sectionTitle}>Closing Costs</Text>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Lender Fees</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.totalLenderFees)}</Text>
            </View>
            {inputs.transactionType === 'developer' && (
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Developer Costs</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.totalDeveloperCosts)}</Text>
            </View>
            )}
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Settlement Charges</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.totalSettlementCharges)}</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Pre-Paids/Escrows</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.totalPrePaids)}</Text>
            </View>
            <View style={[compactStyles.loanStructureRow, { marginTop: 2, paddingTop: 2, borderTopWidth: 1, borderTopColor: colors.border }]}>
              <Text style={[compactStyles.loanStructureLabel, { fontWeight: 700, color: '#002F87' }]}>Total Closing</Text>
              <Text style={[compactStyles.loanStructureValue, { fontWeight: 700, color: '#002F87' }]}>{formatCurrency(data.totalClosingCosts)}</Text>
            </View>
          </View>

          {/* Loan Structure */}
          <View style={compactStyles.column}>
            <Text style={compactStyles.sectionTitle}>Loan Structure</Text>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>{inputs.transactionType === 'refinance_cashout' ? 'Property Value' : 'Purchase Price'}</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.purchasePrice)}</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Interest Rate</Text>
              <Text style={compactStyles.loanStructureValue}>{inputs.interestRate || '-'}% ({inputs.rateType || 'Fixed'})</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Amortization</Text>
              <Text style={compactStyles.loanStructureValue}>{inputs.amortizationTerm || '30'} years</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>Loan-to-Value</Text>
              <Text style={compactStyles.loanStructureValue}>{data.targetLTV}%</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>IO Payment</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.ioPayment)}</Text>
            </View>
            <View style={compactStyles.loanStructureRow}>
              <Text style={compactStyles.loanStructureLabel}>P&I Payment</Text>
              <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.piPayment)}</Text>
            </View>
          </View>
        </View>

        {/* Settlement Charges Breakdown - For Refinance Cash-Out and Purchase */}
        {(inputs.transactionType === 'refinance_cashout' || inputs.transactionType === 'purchase') && (
          <View style={compactStyles.section}>
            <Text style={compactStyles.sectionTitle}>Settlement Charges Breakdown</Text>
            <View style={compactStyles.twoColumn}>
              <View style={compactStyles.column}>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Lender's Title Policy (0.081%)</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.lendersTitlePolicy)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Owner's Title Insurance (0.42%)</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.ownersTitleInsurance)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Documentary Stamps (0.35%)</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.docStamps)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Intangible Stamps (0.20%)</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.intangibleStamps)}</Text>
                </View>
              </View>
              <View style={compactStyles.column}>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Title Search</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.titleSearch)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Title Endorsements</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.titleEndorsements)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Lien Search</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.lienSearch)}</Text>
                </View>
                <View style={compactStyles.loanStructureRow}>
                  <Text style={compactStyles.loanStructureLabel}>Courier/Express Mail</Text>
                  <Text style={compactStyles.loanStructureValue}>{formatCurrency(data.courierExpressMail)}</Text>
                </View>
              </View>
            </View>
            <View style={[compactStyles.loanStructureRow, { marginTop: 4, paddingTop: 4, borderTopWidth: 1, borderTopColor: colors.border, backgroundColor: '#002F87', padding: 6, borderRadius: 2 }]}>
              <Text style={[compactStyles.loanStructureLabel, { fontWeight: 700, color: '#FFFFFF' }]}>Total Settlement Charges</Text>
              <Text style={[compactStyles.loanStructureValue, { fontWeight: 700, color: '#FFFFFF' }]}>{formatCurrency(data.totalSettlementCharges)}</Text>
            </View>
          </View>
        )}

        {/* Assumptions */}
        <View style={compactStyles.assumptions}>
          <Text style={compactStyles.assumptionsTitle}>Notes</Text>
          <Text style={compactStyles.assumptionItem}>• Doc stamps: 0.35% | Intangible tax: 0.2% | Title insurance per FL schedule</Text>
          <Text style={compactStyles.assumptionItem}>• Escrow: {data.escrowTaxMonths} months taxes + {data.escrowInsuranceMonths} months insurance | All figures are estimates subject to final underwriting</Text>
        </View>

        {/* Loan Officer Contact - Compact */}
        {loanOfficer && (
          <View style={compactStyles.loanOfficerSection}>
            <Text style={compactStyles.loanOfficerName}>{loanOfficer.name} | {loanOfficer.title}</Text>
            <Text style={compactStyles.loanOfficerDetail}>
              {loanOfficer.email} | {loanOfficer.phone}{loanOfficer.nmls ? ` | NMLS# ${loanOfficer.nmls}` : ''}
            </Text>
          </View>
        )}

        {/* Footer */}
        <View style={compactStyles.footer}>
          <Text style={compactStyles.disclaimer}>
            This summary is for informational purposes only and does not constitute a loan commitment or offer. 
            All terms are subject to final underwriting, credit approval, and property appraisal. 
            Vaster reserves the right to modify terms at any time.
          </Text>
        </View>
      </Page>
    </Document>
  );
};


// Churchill DSCR PDF Export Component
export const ChurchillDSCRPDF = ({ data, inputs, loanOfficer }) => {
  const formatCurrency = (value) => {
    if (!value && value !== 0) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatPercentage = (value) => {
    if (!value && value !== 0) return '-';
    return `${parseFloat(value).toFixed(2)}%`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Image src={VASTER_LOGO_BASE64} style={styles.logo} />
          </View>
          <Text style={styles.dateText}>Generated: {new Date().toLocaleDateString()}</Text>
        </View>

        {/* Title */}
        <Text style={styles.title}>Churchill DSCR Loan Summary</Text>
        <Text style={styles.subtitle}>
          {inputs?.programName || 'DSCR Base'} • {inputs?.productType || '30Y Fixed'}
        </Text>

        {/* Property & Borrower Info */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Property & Loan Information</Text>
          <View style={styles.projectInfoRow}>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Property Address</Text>
              <Text style={styles.projectInfoValue}>{inputs?.propertyAddress || 'N/A'}</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>State</Text>
              <Text style={styles.projectInfoValue}>{inputs?.propertyState || 'N/A'}</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Property Type</Text>
              <Text style={styles.projectInfoValue}>{inputs?.propertyType || 'N/A'}</Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectInfoLabel}>Loan Purpose</Text>
              <Text style={styles.projectInfoValue}>{inputs?.loanPurpose || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Key Metrics in Grid */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Loan Metrics</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Loan Amount</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(parseFloat(inputs?.loanAmount) || 0)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Property Value</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(parseFloat(inputs?.propertyValue) || 0)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>LTV</Text>
              <Text style={styles.projectInfoValue}>{formatPercentage(data?.ltv)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>FICO Score</Text>
              <Text style={styles.projectInfoValue}>{inputs?.ficoScore || 'N/A'}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>DSCR Ratio</Text>
              <Text style={styles.projectInfoValue}>{inputs?.dscrRatio || 'N/A'}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Prepay Penalty</Text>
              <Text style={styles.projectInfoValue}>{inputs?.prepayPenalty || 'N/A'}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Amortization</Text>
              <Text style={styles.projectInfoValue}>{inputs?.amortizationType || 'N/A'}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Lock Period</Text>
              <Text style={styles.projectInfoValue}>{inputs?.lockPeriod || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Rate & Pricing */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Rate & Pricing</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Selected Rate</Text>
              <Text style={{ ...styles.projectInfoValue, fontWeight: 700, fontSize: 11 }}>
                {data?.selectedRate ? `${data.selectedRate.toFixed(3)}%` : 'N/A'}
              </Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Base Price</Text>
              <Text style={styles.projectInfoValue}>{data?.basePrice?.toFixed(3) || 'N/A'}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>LLPA Total</Text>
              <Text style={styles.projectInfoValue}>
                {data?.totalLLPAAdjustment >= 0 ? '+' : ''}{data?.totalLLPAAdjustment?.toFixed(3) || '0.000'}
              </Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Adjusted Price</Text>
              <Text style={{ ...styles.projectInfoValue, fontWeight: 700 }}>
                {data?.adjustedPrice?.toFixed(3) || 'N/A'}
              </Text>
            </View>
          </View>
        </View>

        {/* LLPA Breakdown */}
        {data?.llpaAdjustments && data.llpaAdjustments.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>LLPA Adjustments Breakdown</Text>
            <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: colors.border, paddingBottom: 4, marginBottom: 4 }}>
              <Text style={{ width: '40%', fontSize: 7, color: colors.textMuted, textTransform: 'uppercase' }}>Category</Text>
              <Text style={{ width: '40%', fontSize: 7, color: colors.textMuted, textTransform: 'uppercase' }}>Description</Text>
              <Text style={{ width: '20%', fontSize: 7, color: colors.textMuted, textTransform: 'uppercase', textAlign: 'right' }}>Adjustment</Text>
            </View>
            {data.llpaAdjustments.map((adj, idx) => (
              <View key={idx} style={{ flexDirection: 'row', marginBottom: 2 }}>
                <Text style={{ width: '40%', fontSize: 8 }}>{adj.category}</Text>
                <Text style={{ width: '40%', fontSize: 8 }}>{adj.description}</Text>
                <Text style={{ width: '20%', fontSize: 8, textAlign: 'right', color: adj.adjustment >= 0 ? '#059669' : '#DC2626' }}>
                  {adj.adjustment >= 0 ? '+' : ''}{adj.adjustment.toFixed(3)}
                </Text>
              </View>
            ))}
          </View>
        )}

        {/* Monthly Payments */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Monthly Payments</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>P&I Payment</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data?.monthlyPI)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>IO Payment</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data?.monthlyIO)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Monthly PITIA</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data?.monthlyPITIA)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Monthly Rent</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(parseFloat(inputs?.monthlyRent) || 0)}</Text>
            </View>
          </View>
        </View>

        {/* Compensation */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Compensation Summary</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>YSP %</Text>
              <Text style={styles.projectInfoValue}>{data?.yspPercent?.toFixed(3) || '0.000'}%</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>YSP Amount</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data?.yspAmount)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Broker Comp</Text>
              <Text style={styles.projectInfoValue}>{formatCurrency(data?.brokerComp)}</Text>
            </View>
            <View style={{ width: '25%', marginBottom: 6 }}>
              <Text style={styles.projectInfoLabel}>Net YSP</Text>
              <Text style={{ ...styles.projectInfoValue, fontWeight: 700, color: colors.primary }}>
                {formatCurrency(data?.netYSP)}
              </Text>
            </View>
          </View>
        </View>

        {/* Loan Officer Contact */}
        {loanOfficer && (
          <View style={{ marginTop: 8, padding: 8, backgroundColor: colors.background, borderRadius: 4 }}>
            <Text style={{ fontSize: 8, fontWeight: 700, color: colors.primary, marginBottom: 4 }}>
              Your Loan Officer
            </Text>
            <Text style={{ fontSize: 9, fontWeight: 700 }}>{loanOfficer.name}</Text>
            {loanOfficer.email && <Text style={{ fontSize: 8, color: colors.textMuted }}>{loanOfficer.email}</Text>}
            {loanOfficer.phone && <Text style={{ fontSize: 8, color: colors.textMuted }}>{loanOfficer.phone}</Text>}
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.disclaimer}>
            This summary is for informational purposes only and does not constitute a loan commitment or offer. 
            All terms are subject to final underwriting, credit approval, and property appraisal. 
            Vaster reserves the right to modify terms at any time. Contact your loan officer for complete details.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Spec Construction Loan Sizer PDF Document Component
export const ConstructionSizerPDF = ({ data, inputs, loanOfficer }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (!data) return null;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image style={styles.logo} src={VASTER_LOGO_BASE64} />
          <Text style={styles.dateText}>Generated: {currentDate}</Text>
        </View>

        {/* Title */}
        <Text style={styles.title}>Construction Loan Summary</Text>
        <Text style={styles.subtitle}>
          Spec Construction | {inputs.projectName || 'New Project'} | {inputs.propertyAddress || 'Address TBD'}
        </Text>

        {/* Executive Summary */}
        <View style={styles.executiveSummary}>
          <Text style={styles.executiveSummaryText}>
            Spec construction financing for {inputs.propertyAddress || '[Property Address]'}:
            Total project cost of {formatCurrency(data.totalProjectCost)} with loan amount of {formatCurrency(data.loanAmount)} ({data.bindingConstraint} constraint binding).
            ARV: {formatCurrency(inputs.arv)} ({formatPercentage(data.actualLTV)} LTV | {formatPercentage(data.actualLTC)} LTC).
            Initial funding at closing: {formatCurrency(data.initialFunding)} with {formatCurrency(data.constructionHoldback)} construction holdback.
            Sponsor equity required: {formatCurrency(data.equity)}.
          </Text>
        </View>

        {/* Key Metrics Row */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Key Metrics</Text>
          <View style={styles.metricsRow}>
            <View style={styles.metricBoxHighlight}>
              <Text style={styles.metricLabelHighlight}>Loan Amount</Text>
              <Text style={styles.metricValueHighlight}>{formatCurrency(data.loanAmount)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Initial Funding</Text>
              <Text style={styles.metricValue}>{formatCurrency(data.initialFunding)}</Text>
            </View>
            <View style={styles.metricBox}>
              <Text style={styles.metricLabel}>Monthly IO Payment</Text>
              <Text style={styles.metricValue}>{formatCurrency(data.monthlyIO)}</Text>
            </View>
            <View style={[styles.metricBox, { backgroundColor: '#FFFBEB' }]}>
              <Text style={[styles.metricLabel, { color: '#B45309' }]}>Equity Required</Text>
              <Text style={[styles.metricValue, { color: '#B45309' }]}>{formatCurrency(data.equity)}</Text>
            </View>
          </View>
        </View>

        {/* Sources and Uses - Two Column */}
        <View style={styles.twoColumn}>
          {/* Sources */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Sources of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Source</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Initial Funding at Closing</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.initialFunding)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Construction Holdback</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.constructionHoldback)}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Sponsor / Developer Equity</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.equity)}</Text>
              </View>
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Sources</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalProjectCost)}</Text>
              </View>
            </View>
          </View>

          {/* Uses */}
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>Uses of Funds</Text>
            <View>
              <View style={styles.tableHeader}>
                <Text style={styles.tableHeaderCell}>Use</Text>
                <Text style={styles.tableHeaderCellRight}>Amount</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Land / Lot Acquisition</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(inputs.landCost)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Hard Construction Costs</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(inputs.hardCosts)}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Soft Costs</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(inputs.softCosts)}</Text>
              </View>
              <View style={styles.tableRowAlt}>
                <Text style={styles.tableCell}>Closing Costs ({formatPercentage(inputs.closingCostRate)})</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.closingCosts)}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Interest Reserve ({data.irMonths.toFixed(1)} mo)</Text>
                <Text style={styles.tableCellRight}>{formatCurrency(data.interestReserve)}</Text>
              </View>
              <View style={styles.tableRowTotal}>
                <Text style={styles.tableCellTotal}>Total Uses</Text>
                <Text style={styles.tableCellTotalRight}>{formatCurrency(data.totalProjectCost)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Loan Sizing Detail */}
        <View style={[styles.section, { marginTop: 10 }]}>
          <Text style={styles.sectionTitle}>Loan Sizing</Text>
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Max Loan by LTV ({formatPercentage(inputs.maxLTV)} of ARV)</Text>
                <Text style={[styles.loanStructureValue, data.bindingConstraint === 'LTV' ? { fontWeight: 700, color: '#002F87' } : {}]}>
                  {formatCurrency(data.maxByLTV)}{data.bindingConstraint === 'LTV' ? ' *' : ''}
                </Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Max Loan by LTC ({formatPercentage(inputs.maxLTC)} of Total Cost)</Text>
                <Text style={[styles.loanStructureValue, data.bindingConstraint === 'LTC' ? { fontWeight: 700, color: '#002F87' } : {}]}>
                  {formatCurrency(data.maxByLTC)}{data.bindingConstraint === 'LTC' ? ' *' : ''}
                </Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Binding Constraint</Text>
                <Text style={[styles.loanStructureValue, { fontWeight: 700, color: '#002F87' }]}>{data.bindingConstraint}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Base Project Cost</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.baseCosts)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Total Project Cost</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.totalProjectCost)}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Actual LTV (of ARV)</Text>
                <Text style={styles.loanStructureValue}>{formatPercentage(data.actualLTV)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Actual LTC (of Total Cost)</Text>
                <Text style={styles.loanStructureValue}>{formatPercentage(data.actualLTC)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Interest Rate</Text>
                <Text style={styles.loanStructureValue}>{formatPercentage(inputs.annualRate, 2)} (Interest-Only)</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Loan Term</Text>
                <Text style={styles.loanStructureValue}>{inputs.termMonths} months</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Total Interest (full term)</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.totalInterestFullTerm)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Initial Funding Detail */}
        <View style={[styles.section, { marginTop: 2 }]}>
          <Text style={styles.sectionTitle}>Initial Funding at Closing</Text>
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Land Value (for lending)</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(inputs.landValue)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Initial Funding Midpoint</Text>
                <Text style={styles.loanStructureValue}>{formatPercentage(inputs.midpointPct)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Gross Land Advance</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.grossInitialFunding)}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Less: Current Debt on Land</Text>
                <Text style={styles.loanStructureValue}>({formatCurrency(inputs.currentDebt)})</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={[styles.loanStructureLabel, { fontWeight: 700, color: '#002F87' }]}>Net Initial Funding</Text>
                <Text style={[styles.loanStructureValue, { fontWeight: 700, color: '#002F87' }]}>{formatCurrency(data.initialFunding)}</Text>
              </View>
              <View style={styles.loanStructureRow}>
                <Text style={styles.loanStructureLabel}>Construction Holdback</Text>
                <Text style={styles.loanStructureValue}>{formatCurrency(data.constructionHoldback)}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Assumptions */}
        <View style={[styles.assumptions, { marginTop: 4, padding: 6, marginBottom: 6 }]}>
          <Text style={styles.assumptionsTitle}>Methodology &amp; Assumptions</Text>
          <Text style={styles.assumptionItem}>• Loan sized to the lesser of {formatPercentage(inputs.maxLTV)} LTV (of ARV) and {formatPercentage(inputs.maxLTC)} LTC (of total project cost)</Text>
          <Text style={styles.assumptionItem}>• Closing costs ({formatPercentage(inputs.closingCostRate)}) and interest reserve ({formatPercentage(inputs.irCoverage, 0)} of term) financed within the loan; LTC solved algebraically</Text>
          <Text style={styles.assumptionItem}>• Initial funding = (Land Value × {formatPercentage(inputs.midpointPct)}) − current land debt; balance disbursed via construction draws</Text>
          <Text style={styles.assumptionItem}>• All figures are estimates subject to final underwriting and appraisal</Text>
        </View>

        {/* Application CTA — identical to Bridge */}
        {loanOfficer?.applicationLink && (
          <View style={[ioiStyles.applyBox, { paddingVertical: 5, marginBottom: 5 }]}>
            <View style={{ flex: 1 }}>
              <Text style={ioiStyles.applyTitle}>Start Your Application Today</Text>
              <Text style={ioiStyles.applySub}>
                Secure online application — takes less than 10 minutes, with no obligation.
                {'\n'}Lock in these terms while they are available.
              </Text>
              <Text style={ioiStyles.applyUrl}>
                Or visit:{' '}
                <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={ioiStyles.applyUrlLink}>
                  {loanOfficer.applicationLink}
                </Link>
              </Text>
            </View>
            <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={ioiStyles.applyBtn}>
              <Text style={ioiStyles.applyBtnText}>APPLY NOW</Text>
            </Link>
          </View>
        )}

        {/* Signature Block */}
        <View style={{ marginBottom: 3 }}>
          <Text style={ioiStyles.sectionTitle}>Acknowledged &amp; Accepted</Text>
          <View style={[ioiStyles.twoCol, { marginTop: 2 }]}>
            <View style={ioiStyles.col}>
              <View style={[ioiStyles.sigLine, { height: 26 }]} />
              <Text style={ioiStyles.sigLabel}>Borrower Signature &amp; Date</Text>
            </View>
            <View style={ioiStyles.col}>
              <View style={[ioiStyles.sigLine, { height: 26, flexDirection: 'row', alignItems: 'flex-end', paddingBottom: 1 }]}>
                <Text style={{ fontFamily: 'GreatVibes', fontSize: 14, color: '#1a2332' }}>
                  {loanOfficer?.name || ''}
                </Text>
              </View>
              <Text style={ioiStyles.sigLabel}>Vaster — Authorized Representative &amp; Date</Text>
            </View>
          </View>
        </View>

        {/* Loan Officer Contact — compact */}
        {loanOfficer && (
          <View style={[ioiStyles.contactRow, { marginBottom: 0 }]}>
            <View>
              <Text style={ioiStyles.contactName}>{loanOfficer.name}</Text>
              <Text style={ioiStyles.contactDetail}>
                {loanOfficer.title}{loanOfficer.nmls ? ` | NMLS#${loanOfficer.nmls}` : ''}
              </Text>
            </View>
            <View>
              <Text style={ioiStyles.contactDetail}>{loanOfficer.phone || ''}</Text>
              <Text style={ioiStyles.contactDetail}>{loanOfficer.email || ''}</Text>
            </View>
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.disclaimer}>
            This summary is for informational purposes only and does not constitute a loan commitment or offer. 
            All terms are subject to final underwriting, credit approval, and property appraisal. 
            Vaster reserves the right to modify terms at any time. Contact your loan officer for complete details.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Compact styles for the one-page Indication of Interest
const ioiStyles = StyleSheet.create({
  page: {
    padding: 28,
    paddingBottom: 24,
    fontSize: 7.5,
    fontFamily: 'Helvetica',
    color: '#1a2332',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    paddingBottom: 7,
    borderBottomWidth: 2,
    borderBottomColor: '#002F87',
  },
  logo: { width: 90, height: 28, objectFit: 'contain' },
  dateText: { fontSize: 7, color: '#637888' },
  title: { fontSize: 15, fontFamily: 'Helvetica-Bold', color: '#002F87', marginBottom: 2 },
  subtitle: { fontSize: 8, color: '#637888', marginBottom: 8 },
  intro: {
    backgroundColor: '#F4F6FA',
    borderLeftWidth: 3,
    borderLeftColor: '#FFFF00',
    padding: 7,
    marginBottom: 9,
  },
  introText: { fontSize: 6.8, lineHeight: 1.4, color: '#3b4757' },
  sectionTitle: {
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    color: '#002F87',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottomWidth: 0.5,
    borderBottomColor: '#D6DDE8',
  },
  section: { marginBottom: 8 },
  infoRow: { flexDirection: 'row', flexWrap: 'wrap' },
  infoItem: { width: '25%', marginBottom: 5, paddingRight: 6 },
  infoItemWide: { width: '50%', marginBottom: 5, paddingRight: 6 },
  infoLabel: { fontSize: 6, color: '#637888', textTransform: 'uppercase', marginBottom: 1 },
  infoValue: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: '#1a2332' },
  twoCol: { flexDirection: 'row', gap: 10 },
  col: { flex: 1 },
  termRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2.8,
    borderBottomWidth: 0.5,
    borderBottomColor: '#EDF0F5',
  },
  termLabel: { fontSize: 7, color: '#3b4757' },
  termValue: { fontSize: 7, fontFamily: 'Helvetica-Bold', color: '#1a2332', textAlign: 'right' },
  bullet: { fontSize: 6.8, color: '#3b4757', marginBottom: 2.4, lineHeight: 1.35 },
  applyBox: {
    backgroundColor: '#002F87',
    borderRadius: 4,
    borderLeftWidth: 4,
    borderLeftColor: '#FFFF00',
    paddingVertical: 8,
    paddingHorizontal: 10,
    marginBottom: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  applyTitle: { fontSize: 9.5, fontFamily: 'Helvetica-Bold', color: '#FFFFFF', letterSpacing: 0.4 },
  applySub: { fontSize: 6.8, color: '#B9C6E4', marginTop: 2.5, lineHeight: 1.35 },
  applyUrl: { fontSize: 6.5, color: '#8FA3D0', marginTop: 3 },
  applyUrlLink: { fontSize: 6.5, color: '#FFFF00', textDecoration: 'underline' },
  applyBtn: {
    backgroundColor: '#FFFF00',
    borderRadius: 12,
    paddingVertical: 7,
    paddingHorizontal: 14,
    marginLeft: 12,
  },
  applyBtnText: { fontSize: 9, fontFamily: 'Helvetica-Bold', color: '#002F87', textDecoration: 'none', letterSpacing: 0.5 },
  sigLine: { borderBottomWidth: 0.8, borderBottomColor: '#1a2332', height: 20, marginBottom: 3 },
  sigLabel: { fontSize: 6.5, color: '#3b4757' },
  sigSub: { fontSize: 6, color: '#637888', marginTop: 1 },
  contactRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F4F6FA',
    padding: 7,
    borderRadius: 3,
    marginBottom: 8,
  },
  contactName: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: '#002F87' },
  contactDetail: { fontSize: 6.5, color: '#3b4757' },
  disclaimer: { fontSize: 5.5, color: '#8a97a8', lineHeight: 1.3 },
});

// Indication of Interest (IOI) PDF Document Component — single page
export const IOIPDF = ({ data, notes = [], loanOfficer }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (!data) return null;

  const isConstruction = (data.product || '').includes('Construction');

  const termRows = [
    ['Product', data.product],
    ['Loan Purpose', data.loanPurpose],
    [data.loanPurpose === 'Purchase' ? 'Purchase Price' : 'Estimated Value', data.appraisedValue ? formatCurrency(data.appraisedValue) : 'TBD'],
    ['Loan Amount', data.loanAmount ? formatCurrency(data.loanAmount) : 'TBD'],
    ['Loan-to-Value (LTV)', data.ltv ? formatPercentage(parseFloat(data.ltv)) : 'TBD'],
    ...(isConstruction && data.ltc ? [['Loan-to-Cost (LTC)', formatPercentage(parseFloat(data.ltc))]] : []),
    ['Interest Rate', data.interestRate || 'TBD'],
    ['Rate Type', data.rateType],
    ['Loan Term', data.loanTerm || 'TBD'],
    ['Interest Guaranty', data.interestGuaranty || 'None'],
    ['Interest Reserve', data.interestReserve || 'None'],
    ['Lender Points', data.lenderPoints ? `${data.lenderPoints}%` : 'TBD'],
    ['Broker Compensation', data.brokerPoints || '0%'],
    ['Extension Option', data.extensionOption || 'None'],
    ['Rate Lock', data.rateLock || 'None'],
  ];
  const half = Math.ceil(termRows.length / 2);
  const termColA = termRows.slice(0, half);
  const termColB = termRows.slice(half);

  const notesHalf = Math.ceil(notes.length / 2);
  const notesColA = notes.slice(0, notesHalf);
  const notesColB = notes.slice(notesHalf);

  const applicationRequirements = [
    'Completed and executed loan application',
    'Government-issued photo ID for all borrowers / guarantors',
    'Entity organizational documents (Articles, OA, EIN letter)',
    'Executed purchase contract (purchase transactions)',
    ...(isConstruction ? ['Construction budget, plans, and permits'] : []),
  ];

  const processSteps = [
    'Execute and return this IOI with the completed application.',
    'Upon approval, a formal Term Sheet / commitment is issued.',
    'Vaster orders third-party reports (appraisal, title).',
    'Underwriting reviews the complete file.',
    'Closing is scheduled once cleared to close.',
  ];

  const s = ioiStyles;

  return (
    <Document>
      <Page size="A4" style={s.page}>
        {/* Header */}
        <View style={s.header}>
          <Image style={s.logo} src={VASTER_LOGO_BASE64} />
          <Text style={s.dateText}>Date: {currentDate}</Text>
        </View>

        {/* Title */}
        <Text style={s.title}>Indication of Interest</Text>
        <Text style={s.subtitle}>
          {data.product} Loan | {data.propertyAddress || 'Property Address TBD'}
        </Text>

        {/* Intro */}
        <View style={s.intro}>
          <Text style={s.introText}>
            Vaster is pleased to provide this non-binding Indication of Interest for the financing described below.
            This letter outlines the general terms under which Vaster would consider providing the requested financing.
            This is not a commitment to lend; all terms are subject to full underwriting, satisfactory appraisal, and
            final credit approval. Any obligation of Vaster shall arise only under definitive loan documents executed by all parties.
          </Text>
        </View>

        {/* Sponsor & Property Information */}
        <View style={s.section}>
          <Text style={s.sectionTitle}>Sponsor &amp; Property Information</Text>
          <View style={s.infoRow}>
            <View style={s.infoItem}>
              <Text style={s.infoLabel}>Sponsor Name</Text>
              <Text style={s.infoValue}>{data.borrowerName || 'TBD'}</Text>
            </View>
            <View style={s.infoItem}>
              <Text style={s.infoLabel}>Borrowing Entity</Text>
              <Text style={s.infoValue}>{data.borrowingEntity || 'TBD'}</Text>
            </View>
            <View style={s.infoItem}>
              <Text style={s.infoLabel}>Property Type</Text>
              <Text style={s.infoValue}>{data.propertyType}</Text>
            </View>
            <View style={s.infoItem}>
              <Text style={s.infoLabel}>Loan Officer</Text>
              <Text style={s.infoValue}>{loanOfficer?.name || '-'}</Text>
            </View>
            <View style={s.infoItemWide}>
              <Text style={s.infoLabel}>Property Address</Text>
              <Text style={s.infoValue}>{data.propertyAddress || 'TBD'}</Text>
            </View>
          </View>
        </View>

        {/* Loan Terms — two columns */}
        <View style={s.section}>
          <Text style={s.sectionTitle}>Proposed Loan Terms</Text>
          <View style={s.twoCol}>
            <View style={s.col}>
              {termColA.map(([label, value]) => (
                <View key={label} style={s.termRow}>
                  <Text style={s.termLabel}>{label}</Text>
                  <Text style={s.termValue}>{value}</Text>
                </View>
              ))}
            </View>
            <View style={s.col}>
              {termColB.map(([label, value]) => (
                <View key={label} style={s.termRow}>
                  <Text style={s.termLabel}>{label}</Text>
                  <Text style={s.termValue}>{value}</Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        {/* Notes */}
        {notes.length > 0 && (
          <View style={s.section}>
            <Text style={s.sectionTitle}>Notes</Text>
            <View style={s.twoCol}>
              <View style={s.col}>
                {notesColA.map((note, i) => (
                  <Text key={i} style={s.bullet}>• {note}</Text>
                ))}
              </View>
              <View style={s.col}>
                {notesColB.map((note, i) => (
                  <Text key={i} style={s.bullet}>• {note}</Text>
                ))}
              </View>
            </View>
          </View>
        )}

        {/* Application Requirements & Process — side by side */}
        <View style={s.section}>
          <View style={s.twoCol}>
            <View style={s.col}>
              <Text style={s.sectionTitle}>Application Requirements</Text>
              {applicationRequirements.map((req, i) => (
                <Text key={i} style={s.bullet}>• {req}</Text>
              ))}
            </View>
            <View style={s.col}>
              <Text style={s.sectionTitle}>Process</Text>
              {processSteps.map((step, i) => (
                <Text key={i} style={s.bullet}>{i + 1}. {step}</Text>
              ))}
            </View>
          </View>
        </View>

        {/* Application CTA — clickable */}
        {loanOfficer?.applicationLink && (
          <View style={s.applyBox}>
            <View style={{ flex: 1 }}>
              <Text style={s.applyTitle}>Start Your Application Today</Text>
              <Text style={s.applySub}>
                Secure online application — takes less than 10 minutes, with no obligation.
                {'\n'}Lock in these terms while they are available.
              </Text>
              <Text style={s.applyUrl}>
                Or visit:{' '}
                <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={s.applyUrlLink}>
                  {loanOfficer.applicationLink}
                </Link>
              </Text>
            </View>
            <Link src={`https://${loanOfficer.applicationLink.replace(/^https?:\/\//, '')}`} style={s.applyBtn}>
              <Text style={s.applyBtnText}>APPLY NOW</Text>
            </Link>
          </View>
        )}

        {/* Signature */}
        <View style={s.section}>
          <Text style={s.sectionTitle}>Acknowledged &amp; Accepted</Text>
          <View style={[s.twoCol, { marginTop: 8 }]}>
            <View style={s.col}>
              <View style={s.sigLine} />
              <Text style={s.sigLabel}>Sponsor Signature &amp; Date</Text>
              <Text style={s.sigSub}>
                {data.borrowerName || 'Sponsor Name'}{data.borrowingEntity ? ` — ${data.borrowingEntity}` : ''}
              </Text>
            </View>
            <View style={s.col}>
              <View style={[s.sigLine, { flexDirection: 'row', alignItems: 'flex-end', paddingBottom: 1 }]}>
                <Text style={{ fontFamily: 'GreatVibes', fontSize: 16, color: '#1a2332' }}>
                  {loanOfficer?.name || ''}
                </Text>
              </View>
              <Text style={s.sigLabel}>Vaster — Authorized Representative &amp; Date</Text>
              <Text style={s.sigSub}>
                {loanOfficer?.name || ''}{loanOfficer?.title ? `, ${loanOfficer.title}` : ''}
              </Text>
            </View>
          </View>
        </View>

        {/* Loan Officer Contact — compact */}
        {loanOfficer && (
          <View style={s.contactRow}>
            <View>
              <Text style={s.contactName}>{loanOfficer.name}</Text>
              <Text style={s.contactDetail}>
                {loanOfficer.title}{loanOfficer.nmls ? ` | NMLS#${loanOfficer.nmls}` : ''}
              </Text>
            </View>
            <View>
              <Text style={s.contactDetail}>{loanOfficer.phone || ''}</Text>
              <Text style={s.contactDetail}>{loanOfficer.email || ''}</Text>
            </View>
          </View>
        )}

        {/* Footer */}
        <Text style={s.disclaimer}>
          This Indication of Interest is for informational purposes only and does not constitute a loan commitment or
          offer. All terms are subject to final underwriting, credit approval, and property appraisal. Vaster reserves
          the right to modify terms at any time. Contact your loan officer for complete details.
        </Text>
      </Page>
    </Document>
  );
};

export default LoanSummaryPDF;
